import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import OrderForm from "../../../components/Dashboard/Dashboard/OrderForm";

const TradeModeSection = ({
  type, // "buy" | "sell"
  coin,
  tradeMode, // "Spot" | "Futures (100x)"
  onTradeSuccess,
  orderDetails,
  from,
}) => {
  return (
    <div className="px-3">
      <OrderForm
        type={type}
        coin={coin}
        from={from}
        orderDetails={orderDetails}
        tradeMode={tradeMode}
        onTradeSuccess={onTradeSuccess}
      />
    </div>
  );
};

const Trade = ({ coin, onTradeSuccess, from = null, orderDetails = null }) => {
  const [tradeMode] = useState(from ? from : "Spot");
  const [activeTab, setActiveTab] = useState("Navbuy");

  // --- Lock tab if Futures + orderDetails ---
  useEffect(() => {
    if (from === "Futures" && orderDetails?.transactionType) {
      setActiveTab(
        orderDetails.transactionType.toLowerCase() === "buy"
          ? "Navbuy"
          : "Navsell"
      );
    }
  }, [from, orderDetails]);

  // Handle trade success
  const handleTradeSuccess = () => {
    onTradeSuccess?.();
  };

  return (
    <div className="card h-auto">
      <div className="card-body px-0 pt-1">
        <Tab.Container
          activeKey={activeTab}
          onSelect={(key) => setActiveTab(key)}
        >
          {/* Buy / Sell Tabs */}
          <div className="buy-sell px-3 mb-3">
            <Nav className="nav nav-tabs" role="tablist">
              {from === "Futures" && orderDetails ? (
                // Only one tab visible
                orderDetails.transactionType.toLowerCase() === "buy" ? (
                  <Nav.Link
                    as="button"
                    className="nav-link text-capitalize fw-semibold active"
                    eventKey="Navbuy"
                    type="button"
                  >
                    Buy
                  </Nav.Link>
                ) : (
                  <Nav.Link
                    as="button"
                    className="nav-link text-capitalize fw-semibold active"
                    eventKey="Navsell"
                    type="button"
                  >
                    Sell
                  </Nav.Link>
                )
              ) : (
                // Show both normally
                <>
                  <Nav.Link
                    as="button"
                    className="nav-link text-capitalize fw-semibold"
                    eventKey="Navbuy"
                    type="button"
                  >
                    Buy
                  </Nav.Link>
                  <Nav.Link
                    as="button"
                    className="nav-link text-capitalize fw-semibold"
                    eventKey="Navsell"
                    type="button"
                  >
                    Sell
                  </Nav.Link>
                </>
              )}
            </Nav>
          </div>

          {/* Tab Content */}
          <Tab.Content>
            <Tab.Pane eventKey="Navbuy">
              <TradeModeSection
                type="buy"
                coin={coin}
                tradeMode={tradeMode}
                onTradeSuccess={handleTradeSuccess}
                from={from}
                orderDetails={orderDetails}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="Navsell">
              <TradeModeSection
                type="sell"
                coin={coin}
                tradeMode={tradeMode}
                onTradeSuccess={handleTradeSuccess}
                from={from}
                orderDetails={orderDetails}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

export default Trade;
